import { TransparencyPortalMapType } from "../../../types/types";
import { api } from "../api";

/**
 * Consulta pública (sem login): placa e localização dos veículos do cliente dono do link.
 * /public/transparency-portal/{token}
 */
const findTransparencyPortalMap = async (linkToken: string) => {
    return api.get<TransparencyPortalMapType>(`/public/transparency-portal/${encodeURIComponent(linkToken)}`);
};

export default findTransparencyPortalMap;
